import React from "react";
import "./LearnMore.css";
import Header from "../components/layout/Header";
import Footer from "../pages/Footer";
import heroImg from "../assets/suvidha-learnmore-hero.png";

const UserGroupIcon = () => (
  <svg
    width="52"
    height="52"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="32" cy="32" r="30" fill="#1976D2" />

    <circle cx="32" cy="25" r="7" fill="white" />
    <circle cx="20" cy="29" r="5" fill="white" />
    <circle cx="44" cy="29" r="5" fill="white" />

    <path
      d="M19 45C19 38.5 24.8 34 32 34C39.2 34 45 38.5 45 45"
      fill="white"
    />

    <path
      d="M8 44C8.5 39.5 12.2 36.5 17 36.5C18.8 36.5 20.4 37 21.8 37.8C19.7 40 18.3 42.4 18 45H8V44Z"
      fill="white"
    />

    <path
      d="M46 37.8C47.4 37 49 36.5 50.8 36.5C55.6 36.5 59.5 39.5 60 44V45H50C49.7 42.4 48.3 40 46 37.8Z"
      fill="white"
    />
  </svg>
);

const ShieldIcon = () => (
  <svg
    width="52"
    height="52"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="32" cy="32" r="30" fill="#F58220" />

    <path
      d="M32 14L47 20V30C47 40.5 40.8 47.5 32 51C23.2 47.5 17 40.5 17 30V20L32 14Z"
      stroke="white"
      strokeWidth="3"
      strokeLinejoin="round"
    />

    <path
      d="M32 25C29.7 21.5 24 22.4 24 27.2C24 32 32 37 32 37C32 37 40 32 40 27.2C40 22.4 34.3 21.5 32 25Z"
      fill="white"
    />
  </svg>
);

const HandshakeIcon = () => (
  <svg
    width="52"
    height="52"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="32" cy="32" r="30" fill="#1976D2" />

    <path
      d="M14 27L23 20L30 23L35 20L43 23L50 30"
      stroke="white"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <path
      d="M14 27L20 34L25 30L32 38L37 34L43 40L50 32"
      stroke="white"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <path
      d="M23 20L29 26"
      stroke="white"
      strokeWidth="3"
      strokeLinecap="round"
    />

    <path
      d="M35 20L30 26"
      stroke="white"
      strokeWidth="3"
      strokeLinecap="round"
    />
  </svg>
);

const LeafDecoration = () => (
  <svg
    className="leaf-decoration"
    width="150"
    height="180"
    viewBox="0 0 150 180"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M75 160C73 117 82 73 110 30"
      stroke="#C8E3FA"
      strokeWidth="4"
      strokeLinecap="round"
    />

    <path
      d="M79 105C56 92 45 72 49 52C71 58 84 76 79 105Z"
      fill="#C8E3FA"
      opacity="0.8"
    />

    <path
      d="M88 83C84 57 94 35 113 24C119 46 109 69 88 83Z"
      fill="#C8E3FA"
      opacity="0.8"
    />

    <path
      d="M71 126C49 119 35 102 35 83C57 88 70 102 71 126Z"
      fill="#C8E3FA"
      opacity="0.8"
    />
  </svg>
);

const LearnMore = () => {
  return (
    <div className="learn-more-page">

      {/* ================= HEADER ================= */}
      <Header/>
   


      {/* ================= HERO ================= */}
      <section className="lm-hero">

        <div className="lm-hero-content">

          <div className="lm-small-title">
            FAMILIES TRUST US. SENIORS LOVE US.
          </div>

          <h1>
            Because Being Far Away
            <br />
            Shouldn’t Mean Being
            <br />
            Out of Reach
          </h1>

          <div className="lm-orange-line"></div>

          <p>
            Suvidha was created for families who want their parents
            to continue living independently, confidently, and
            comfortably — even when their children cannot always
            be physically present.
          </p>

        </div>

        <div className="lm-hero-image">
          <img
            src={heroImg}
            alt="Elder care support"
          />
        </div>

      </section>


      {/* ================= WHY SUVIDHA ================= */}
      <section className="lm-why">

        <div className="lm-container">

          <div className="lm-why-content">

            <h2>
              Why Suvidha Exists
            </h2>

            <p>
              For many families, life takes children to different
              cities and countries while their parents continue to
              call India home. That distance can make even simple
              things — a doctor visit, a hospital admission,
              recovery after illness, or an unexpected emergency —
              difficult to manage.
            </p>

            <h3>
              Suvidha bridges that distance.
            </h3>

            <p className="lm-last-paragraph">
              We become the dependable support system around your
              parents, making sure the right help is available when
              they need it.
            </p>

          </div>

          <div className="lm-side-message">

            <LeafDecoration />

            <div className="handwritten-text">
              <span>Always</span>
              <br />
              <span>by their side</span>

              <div className="handwritten-line"></div>
            </div>

          </div>

        </div>

      </section>


      {/* ================= WHO WE ARE ================= */}
      <section className="lm-who">

        <div className="lm-container">

          <h2>
            Who We Are
          </h2>

          <p className="lm-intro">
            Suvidha is more than an elder care service. We bring
            together healthcare, rehabilitation, hospital assistance,
            companionship, everyday support, and care coordination
            through one trusted team.
          </p>

          <p className="lm-intro second">
            Our relationship with every senior is personal. We take
            time to understand their routines, preferences, health
            needs, and changing requirements so that care feels
            familiar rather than transactional.
          </p>


          {/* ================= CARDS ================= */}
          <div className="lm-cards">

            <div className="lm-card lm-card-blue">

              <div className="lm-icon">
                <UserGroupIcon />
              </div>

              <h3>
                Someone
                <br />
                knows your parents.
              </h3>

              <p>
                Familiar care built around their routines,
                preferences, and needs.
              </p>

            </div>


            <div className="lm-card lm-card-orange">

              <div className="lm-icon">
                <ShieldIcon />
              </div>

              <h3>
                Someone
                <br />
                is watching out for them.
              </h3>

              <p>
                Regular support, follow-ups, and attention
                when something changes.
              </p>

            </div>


            <div className="lm-card lm-card-blue">

              <div className="lm-icon">
                <HandshakeIcon />
              </div>

              <h3>
                Someone is there
                <br />
                when you can’t be.
              </h3>

              <p>
                Trusted assistance for everyday needs,
                hospital visits, and unexpected moments.
              </p>

            </div>

          </div>


          {/* ================= BOTTOM MESSAGE ================= */}
          <div className="lm-bottom-message">

            <div className="message-line"></div>

            <div className="heart">
              ♥
            </div>

            <div className="message-line"></div>

          </div>

          <div className="lm-final-text">
            Caring for their today. Giving you a more peaceful tomorrow.
          </div>

          <div className="lm-bottom-lines">
            <span></span>
            <span></span>
          </div>

        </div>

      </section>

      <Footer />

    </div>
  );
};

export default LearnMore;